import React from 'react'

import MarkdownHelper from '../utils/MarkdownHelper'
import ReactMarkdown from 'react-markdown'

const TermsAndConditions = props => {

    const renderTitle = () => {

        if (props.isApp) {
            return (
                <h2 className="terms-and-conditions__title__text">
                   {props.title}
                </h2>
            )
        } else {
            return (
                <div className="terms-and-conditions__title">
                    <div className="mam-icn mam-icn--arrow mam-icn--arrow--up"></div>

                    <span className="terms-and-conditions__title__text">
                        {props.title}
                     </span>
                </div>
            )
        }
    }

    if (props.content) {
        return (
            <div className="terms-and-conditions">
                {renderTitle(props)}
                <div className="terms-and-conditions__container">
                    <ReactMarkdown {...MarkdownHelper.allTypes()}
                                   source={MarkdownHelper.parse(props.content)} />
                </div>
            </div>

        )
    } else {
        return false;
    }
}

export default TermsAndConditions



// WEBPACK FOOTER //
// ./src/components/subcomponents/TermsAndConditions.js